
















































































































































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {Helper, InputCheckbox} from 'simpli-web-sdk'
import FileManager from '@/components/FileManager.vue'
import {InputPanelUserSchema} from '@/schema/resource/PanelUser/InputPanelUserSchema'
import {PanelUser} from '@/model/resource/PanelUser'
import {InputAddressSchema} from '@/schema/resource/Address/InputAddressSchema'
import {InputPanelUserFlagsWithOptionsSchema} from '@/schema/resource/PanelUser/InputPanelUserFlagsWithOptionsSchema'
import InputTipoCliente from '@/components/InputTipoCliente.vue'
import {PanelUserInfo} from '@/model/resource/PanelUserInfo'
import {InputPanelUserFlagsSchema} from '@/schema/resource/PanelUser/InputPanelUserFlagsSchema'
import {InputPanelUserPasswordSchema} from '@/schema/resource/PanelUser/InputPanelUserPasswordSchema'
import InputTipoClienteInternational from '@/components/InputTipoClienteInternational.vue'
import {UserTypeEnum} from '@/enums/UserTypeEnum'
import {TipoCliente} from '@/enums/TipoCliente'

@Component({
  computed: {
    UserTypeEnum() {
      return UserTypeEnum
    },
  },
  components: {
    InputTipoClienteInternational,
    InputTipoCliente,
    FileManager,
    InputCheckbox,
  },
})
export default class PersistPanelUserView extends Vue {
  @Prop() id?: string

  isShipper: boolean = true
  isTransporter: boolean = false

  @Provide('validator') validator = this.$validator
  schema = new InputPanelUserSchema()
  panelUserFlagsSchema = new InputPanelUserFlagsSchema()
  addressSchema = new InputAddressSchema()
  panelUserFlagsWithOptionsSchema = new InputPanelUserFlagsWithOptionsSchema()
  panelUserPasswordSchema = new InputPanelUserPasswordSchema()
  panelUser = PanelUser.buildNew()
  Helper = Helper

  async created() {
    if (this.panelUser.panelUserInfo == null) {
      this.panelUser.panelUserInfo = PanelUserInfo.buildNew()
    }
    await this.populate()
  }

  get registrantEmail() {
    return this.panelUser.panelUserInfo?.administrator?.email || '-'
  }

  setPartnerName(val: string) {
    if (this.panelUser.panelUserInfo == null) {
      this.panelUser.panelUserInfo = new PanelUserInfo()
    }
    this.panelUser.panelUserInfo.partnerName = val
  }

  async populate() {
    await this.schema.collectionVisualizationMode.queryAsPage()

    const id = Number(this.id) || null
    if (id) {
      await this.panelUser.getPanelUser(id)
      this.populateUserType()
    }
  }

  populateUserType() {
    switch (this.panelUser.idUserTypeFk) {
      case UserTypeEnum.SHIPPER:
        this.isShipper = true
        this.isTransporter = false
        break
      case UserTypeEnum.TRANSPORTER:
        this.isShipper = false
        this.isTransporter = true
        break
      default:
        this.isShipper = true
        this.isTransporter = true
    }
    this.updateUserType()
  }

  async persist() {
    this.formatData()
    const isValid = await this.validateAllInputs()
    if (isValid) {
      await this.panelUser.persistPanelUser()
      await Helper.successAndPush(
        'system.success.persist',
        '/internacional/responsavel/list'
      )
    }
  }

  updateUserType(val?: UserTypeEnum) {
    if (this.isTransporter && this.isShipper) {
      this.panelUser.idUserTypeFk = UserTypeEnum.HYBRID
    } else if (this.isTransporter) {
      this.panelUser.idUserTypeFk = UserTypeEnum.TRANSPORTER
    } else if (this.isShipper) {
      this.panelUser.idUserTypeFk = UserTypeEnum.SHIPPER
    } else {
      if (val == UserTypeEnum.SHIPPER) {
        this.isTransporter = true
        this.panelUser.idUserTypeFk = UserTypeEnum.TRANSPORTER
      } else {
        this.isShipper = true
        this.panelUser.idUserTypeFk = UserTypeEnum.SHIPPER
      }
    }
  }

  async validateAllInputs(): Promise<boolean> {
    const {isSenhaResponsavelMatch} = this.panelUserPasswordSchema
    const isValid = await this.validator.validateAll()
    const isFlagsValid = this.isFlagsValid()
    const isPasswordConfirmationValid = isSenhaResponsavelMatch ?? true
    const isPasswordValid =
      isPasswordConfirmationValid &&
      ((this.panelUser.idPanelUserPk === 0 && !!this.panelUser.password) ||
        this.panelUser.idPanelUserPk !== 0)
    if (isValid && isPasswordValid && isFlagsValid) return true
    if (this.validator.errors.items.length > 1) {
      // Multiplas validações automáticas
      Helper.abort('system.error.validation')
    } else if (this.validator.errors.items.length === 1) {
      // Uma unica validação automática
      Helper.abort(
        this.$t('system.error.fieldIsNotValid', {
          field: this.validator.errors.items[0].field,
        }) as string
      )
    } else if (
      this.panelUser.dueDate &&
      Date.parse(this.panelUser.dueDate) < Date.now()
    ) {
      //Data já passou
      Helper.abort('system.error.invalidDataVencimento')
    } else if (!isPasswordConfirmationValid) {
      //senhas não são iguais
      Helper.abort('system.error.passwordConfirmationFails')
    } else {
      //senhas não preenchida para novo panel user
      Helper.abort('system.error.passwordIsNotValid')
    }
    return false
  }

  isFlagsValid(): boolean {
    let isFlagsOptionsValid = false
    if (this.panelUser.panelUserInfo && this.panelUser.panelUserFlags) {
      const info = this.panelUser.panelUserInfo
      const flags = this.panelUser.panelUserFlags
      const panelUserTypeValid =
        info.idPanelUserTypeFk == TipoCliente.Cliente ||
        (info.idPanelUserTypeFk == TipoCliente.Parceiro && !!info.partnerName)
      const tmsFlagValid =
        !flags.integrationEnabled ||
        (flags.integrationEnabled && !!info.tmsIntegration)
      const towerControllFlagValid =
        !flags.hasControlTower ||
        (flags.hasControlTower && !!info.towerControlManagerName)
      isFlagsOptionsValid =
        tmsFlagValid && towerControllFlagValid && panelUserTypeValid
    }
    return isFlagsOptionsValid
  }

  formatData() {
    this.panelUser.corporateName =
      this.panelUser.corporateName?.toUpperCase() ?? null
    this.panelUser.active = this.panelUser.active ?? true
    this.panelUser.contactName =
      this.panelUser.contactName?.toUpperCase() ?? null
    this.panelUser.email = this.panelUser.email?.toUpperCase() ?? null

    if (this.panelUser.panelUserInfo) {
      this.panelUser.panelUserInfo.idAdministradorFk = this.$auth.administrador
        ?.idAdministradorPk as number
    }

    if (this.panelUser.address) {
      this.panelUser.address.street =
        this.panelUser.address.street?.toUpperCase() ?? null
      this.panelUser.address.number =
        this.panelUser.address.number?.toUpperCase() ?? null
      this.panelUser.address.city =
        this.panelUser.address.city?.toUpperCase() ?? null
      this.panelUser.address.state =
        this.panelUser.address.state?.toUpperCase() ?? null
      this.panelUser.address.zipcode =
        this.panelUser.address.zipcode?.toUpperCase() ?? null
    }
  }
}
